import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'

export const MenuContext = createContext({
    isCatalogMenuOpen: true,
    toggleMenuMode: () => {}
})

const CatalogMenuState = ({ children }) => {
    const [isCatalogMenuOpen, toggleMenu] = useState(false)

    const toggleMenuMode = () => {
        toggleMenu(!isCatalogMenuOpen)
    }

    return (
        <MenuContext.Provider
            value={{
                isCatalogMenuOpen,
                toggleMenuMode
            }}>
            {children}
        </MenuContext.Provider>
    )
}

CatalogMenuState.propTypes = {
    children: PropTypes.node.isRequired
}

export default CatalogMenuState
